<template>
  <div>
    <div>
      <basicHeader
        :title="$t('setup.label.CreateTaxMaster')"
        @backPress="$router.push(`/setup/tax`)"
      />
    </div>
    <ValidationObserver ref="observer">
      <vx-card class="form-padding">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.TaxCode')"
            >
              <vs-input
                :label="$t('setup.label.TaxCode')"
                v-model="taxCode"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.GroupType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.GroupType')"
              >
                <v-select
                  label="mCodeValue"
                  :reduce="(obj) => obj.mCodeValue"
                  :options="taxTemplate.taxGroupData"
                  v-model="groupType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.Type")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Type')"
              >
                <v-select
                  label="mCodeValue"
                  :reduce="(obj) => obj.mCodeValue"
                  :options="taxTemplate.taxTypeData"
                  v-model="type"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("setup.label.GroupCode")
              }}</small>

              <v-select
                label="groupTaxCodes"
                :reduce="(obj) => obj.groupTaxCodes"
                :options="taxTemplate.grouptaxcodes"
                v-model="groupCode"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              >
                <template v-slot:option="option">{{
                  option.groupTaxCodes
                }}</template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("setup.label.StartDate")
              }}</small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.StartDate')"
              >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="startDate"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                  :disabled-dates="{ from: new Date() }"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{ $t("setup.label.EndDate") }}</small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EndDate')"
              >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="endDate"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                  :disabled-dates="{ to: new Date(new Date().toDateString()) }"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col md:w-1/2 w-full" v-if="type == 'TaxOnTax'">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.BaseTaxCode")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.BaseTaxCode')"
              >
                <v-select
                  label="taxCodes"
                  :reduce="(obj) => obj.taxCodes"
                  :options="taxTemplate.taxcodes"
                  v-model="baseTaxCode"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.taxCodes
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="center">
          <span class="ml-3 mr-4">
            <vs-button
              type="border"
              style="width: 190px; margin-top: 20px; margin-bottom: 10px"
              @click="resetForm"
              >{{ $t("setup.label.Reset") }}</vs-button
            >
          </span>
          <span class="ml-1 mr-2">
            <vs-button style="width: 190px" @click="handleCreateTax">{{
              $t("setup.label.Submit")
            }}</vs-button>
          </span>
        </div>
      </vx-card>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import basicHeader from "@/components/common/basicHeader";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import { mapState } from "vuex";
export default {
  components: {
    basicHeader,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    "v-select": vSelect,
  },
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      taxCode: "",
      groupType: "",
      startDate: "",
      endDate: "",
      type: "",
      baseTaxCode: "",
      groupCode: "",
      rateTypes: ["Percentage", "Flat"],
    };
  },
  computed: {
    ...mapState({
      taxTemplate: (state) => state.taxmap.taxTemplate,
    }),
  },
  methods: {
    async handleCreateTax() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let payload = {
        taxCode: this.taxCode,
        groupType: this.groupType,
        groupCode: this.groupCode,
        type: this.type,
        startDate: moment(this.startDate).format("YYYY-MM-DD"),
        endDate: moment(this.endDate).format("YYYY-MM-DD"),
        dateFormat: "yyyy-MM-dd",
        locale: "en",
        baseTaxcode: this.baseTaxCode,
      };
      try {
        await this.$store.dispatch("taxmap/createTaxAction", payload);
        this.$router.push(`/setup/tax`);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Tax Master Created Successfully!",
          type: "success",
        });
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.taxCode = "";
      this.groupType = "";
      this.groupCode = "";
      this.type = "";
      this.startDate = "";
      this.endDate = "";
      this.baseTaxCode = "";
      this.$refs.observer.reset();
    },
  },
  async mounted() {
    await this.$store.dispatch("taxmap/fetchTaxTemplate");
  },
};
</script>
